import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const DonateAddQr = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [filePath, setFilePath] = useState('');
  const navi=useNavigate()
  // Handle file input change
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setMessage('Please select an image file');
      return;
    }

    // Prepare form data to send the file
    const formData = new FormData();
    formData.append('file', file);

    try {
      // Send the file to the backend
      const response = await axios.post(`${process.env.REACT_APP_API}/addqrimg/addqr`, formData, {
        // navi('')
        headers: {
          'Content-Type': 'multipart/form-data',
        },
       
      });
      navi('/donate')
      // Handle success response
      setMessage(response.data.message);
      setFilePath(response.data.filePath); // Get the file path from the response
    } catch (error) {
      // Handle error response
      setMessage('Error uploading file: ' + (error.response ? error.response.data.message : error.message));
    }
  };


  return (
    <div>
      <h1>Donate QR Code</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <input type="file" onChange={handleFileChange} />
        </div>
        <button type="submit">Upload</button>
      </form>

      {message && <p>{message}</p>}
      {filePath && (
        <div>
          <h3>Uploaded QR Code:</h3>
          <img src={`${process.env.REACT_APP_API}/${filePath}`} alt="Uploaded QR Code" style={{ maxWidth: '200px' }} />
        </div>
      )}
    </div>
  );
};

export default DonateAddQr;
